import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { ClaimantService } from '../../services/claimant/claimant.service';
import { Claimant } from '../../models/claimant';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { Authenticate } from '../../models/authenticate';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-agree',
  templateUrl: './agree.html',
  styleUrls: ['./agree.css'],
  imports: [ReactiveFormsModule, CurrencyPipe, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class Agree implements OnInit {
  submitted = false;
  clicked = false;
  clickedOnce = false;
  changed = false;
  allStates: any = [];
  allCountries: any = [];
  claimantsInformation: FormGroup;
  submittedClaim: Claimant;
  au: Authenticate;
  response: string | undefined;
  dateLoaded: Date;
  claimStartTime: string;
  claimEndTime: string;
  showSubmittalErrorWarning: boolean = false;

  showDivProvince: boolean = false;
  showDivCityStateZip: boolean = true;
  selectedCountry: any;

  constructor(
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private claimantService: ClaimantService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.dateLoaded = new Date();
    this.dateLoaded = new Date();
    this.claimStartTime = this.dateLoaded.toLocaleTimeString();
    this.loadAllStates();
    this.loadAllCountries();
    //this.selectedCountry = "United States";
    this.au = this.storage.retrieve('authenticatedUser');
    // The API currently returns this monetary value as a comma-formatted string.
    // DecimalPipe requires a numeric value when formatting it in the template.
    this.au.purchaseNetTotal = Number(String(this.au.purchaseNetTotal).replace(/,/g, ''));
    this.claimantsInformation = this.fb.group({
      pin: [this.au.pin],
      uniqueId: [this.au.uniqueId],
      purchaseNetTotal: [this.au.purchaseNetTotal],

      butterball2010: [this.au.butterball2010],
      butterball2011: [this.au.butterball2011],
      butterball2012: [this.au.butterball2012],
      butterball2013: [this.au.butterball2013],
      butterball2014: [this.au.butterball2014],
      butterball2015: [this.au.butterball2015],
      butterball2016: [this.au.butterball2016],

      cargill2010: [this.au.cargill2010],
      cargill2011: [this.au.cargill2011],
      cargill2012: [this.au.cargill2012],
      cargill2013: [this.au.cargill2013],
      cargill2014: [this.au.cargill2014],
      cargill2015: [this.au.cargill2015],
      cargill2016: [this.au.cargill2016],

      cooperFarms2010: [this.au.cooperFarms2010],
      cooperFarms2011: [this.au.cooperFarms2011],
      cooperFarms2012: [this.au.cooperFarms2012],
      cooperFarms2013: [this.au.cooperFarms2013],
      cooperFarms2014: [this.au.cooperFarms2014],
      cooperFarms2015: [this.au.cooperFarms2015],
      cooperFarms2016: [this.au.cooperFarms2016],

      farbestFoods2010: [this.au.farbestFoods2010],
      farbestFoods2011: [this.au.farbestFoods2011],
      farbestFoods2012: [this.au.farbestFoods2012],
      farbestFoods2013: [this.au.farbestFoods2013],
      farbestFoods2014: [this.au.farbestFoods2014],
      farbestFoods2015: [this.au.farbestFoods2015],
      farbestFoods2016: [this.au.farbestFoods2016],

      fosterFarms2010: [this.au.fosterFarms2010],
      fosterFarms2011: [this.au.fosterFarms2011],
      fosterFarms2012: [this.au.fosterFarms2012],
      fosterFarms2013: [this.au.fosterFarms2013],
      fosterFarms2014: [this.au.fosterFarms2014],
      fosterFarms2015: [this.au.fosterFarms2015],
      fosterFarms2016: [this.au.fosterFarms2016],

      hormel2010: [this.au.hormel2010],
      hormel2011: [this.au.hormel2011],
      hormel2012: [this.au.hormel2012],
      hormel2013: [this.au.hormel2013],
      hormel2014: [this.au.hormel2014],
      hormel2015: [this.au.hormel2015],
      hormel2016: [this.au.hormel2016],

      perdue2010: [this.au.perdue2010],
      perdue2011: [this.au.perdue2011],
      perdue2012: [this.au.perdue2012],
      perdue2013: [this.au.perdue2013],
      perdue2014: [this.au.perdue2014],
      perdue2015: [this.au.perdue2015],
      perdue2016: [this.au.perdue2016],

      prestage2010: [this.au.prestage2010],
      prestage2011: [this.au.prestage2011],
      prestage2012: [this.au.prestage2012],
      prestage2013: [this.au.prestage2013],
      prestage2014: [this.au.prestage2014],
      prestage2015: [this.au.prestage2015],
      prestage2016: [this.au.prestage2016],

      tyson2010: [this.au.tyson2010],
      tyson2011: [this.au.tyson2011],
      tyson2012: [this.au.tyson2012],
      tyson2013: [this.au.tyson2013],
      tyson2014: [this.au.tyson2014],
      tyson2015: [this.au.tyson2015],
      tyson2016: [this.au.tyson2016],

      nameOne: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      attention: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      streetOne: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      streetTwo: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state: ['', Validators.compose([Validators.required])],
      country: ['', Validators.compose([Validators.required])],
      province: ['', Validators.compose([Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      postalCode: [''],
      zip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      phoneType: ['', Validators.compose([Validators.required])],
      phoneNumber: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      agreeOrDisagree: ['Agree'],
      email: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("^[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      title: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      googleRecaptchaToken: ['', Validators.compose([Validators.required])],

    });
  }

  loadAllStates() {
    this.httpClient.get("assets/States.json").subscribe(data => {
      /* console.log(data);*/
      this.allStates = data;
    })
  }

  loadAllCountries() {
    this.httpClient.get("assets/Countries.json").subscribe(data => {
      console.log(data);
      this.allCountries = data;
      this.cdr.detectChanges();
    })
  }

  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  get f() { return this.claimantsInformation.controls; }

  getCountryValue($event) {
    this.changed = true;
    // if you need the event source and value it can be accessed.
    console.log($event.target.value);
    if ($event.target.value !== 'United States') {
      this.showDivProvince = true;
      this.showDivCityStateZip = false;

      this.claimantsInformation.get('state').clearValidators();
      this.claimantsInformation.get('state').updateValueAndValidity();
      this.claimantsInformation.get('state').reset();
      this.claimantsInformation.get('zip').clearValidators();
      this.claimantsInformation.get('zip').updateValueAndValidity();
      this.claimantsInformation.get('zip').reset();
      this.claimantsInformation.get('city').reset();
      this.claimantsInformation.get('postalCode').setValidators(Validators.compose([Validators.maxLength(10)]));
      this.claimantsInformation.get('province').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    }

    if ($event.target.value === 'United States') {
      /* */
      this.showDivProvince = false;
      this.showDivCityStateZip = true;

      this.claimantsInformation.get('city').reset();
      this.claimantsInformation.get('province').reset();
      this.claimantsInformation.get('postalCode').reset();

      this.claimantsInformation.get('province').clearValidators();
      this.claimantsInformation.get('province').updateValueAndValidity();
      this.claimantsInformation.get('postalCode').clearValidators();
      this.claimantsInformation.get('postalCode').updateValueAndValidity();

      this.claimantsInformation.get('city').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.claimantsInformation.get('state').setValidators(Validators.compose([Validators.required]));
      this.claimantsInformation.get('zip').setValidators(Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")]));
    }
  }



  onSubmit() {
    this.submitted = true;
    this.dateLoaded = new Date();
    this.claimEndTime = this.dateLoaded.toLocaleTimeString();

    // stop here if form is invalid
    if (this.claimantsInformation.invalid) {
      return;
    }

    this.clicked = true;
    const claimant = this.claimantsInformation.value;
    claimant.claimStartTime = this.claimStartTime;
    claimant.claimEndTime = this.claimEndTime;

    this.spinner.show();

    /*console.log(claimant);*/
    this.CreateClaimant(claimant);
  }

  CreateClaimant(claimant: Claimant) {
    const message = "Unable to save claimant data.";

    this.claimantService.createClaimant(claimant).subscribe(res => {
      this.submittedClaim = res;
      if (this.submittedClaim.statusMessage === message) {
        this.showSubmittalErrorWarning = true;
        return;
      }
      this.storage.store('claimant', this.submittedClaim);
      // this.submitted = false;
      this.claimantsInformation.reset();
      this.spinner.hide();
      this.router.navigate(['/complete']);
    });
  }
}
